import team from "./Assets/team.gif";
import Becceptor from "./Assets/sponsorsLogos/becceptor.png";
import igl from "./Assets/sponsorsLogos/igl.png";
import upSec from "./Assets/sponsorsLogos/upsec.png";


import Yash from "./Assets/teami/Yash.jpg"
import Rajan from "./Assets/teami/Rajan.jpg"
import RK_Chauhan from "./Assets/teami/Chauhan.jpg"
import Harshit from "./Assets/teami/Harshit.jpg"
import Aditya from "./Assets/teami/Aditya.jpg"
import Deepak from "./Assets/teami/Deepak.jpg"
import Prabhakar from "./Assets/teami/Prabhakar.jpg"
import Shivanand from "./Assets/teami/Shivanand.jpg"
import Aaryama from "./Assets/teami/Aaryama.jpeg"

const TOP_SECTION = {
  TITLE: "HackFest'23",
  Typed_effect: ["03 Feb - 05 Feb", "24 hours of creation", "Win awesome prizes"],
  SHORT_DESCRIPTION:
    "Join us on 04th and 05th of Feb 2023 for 24 hours of creation, innovation, & fun with over 200+ students.",
  IMG_SRC: team,
  DISCORD_LINK: "https://discord.gg/v5Jz567Q",
  JUDGES_FORM_LINK:
    "#Jugdes Form Link",
  HACKERS_REGISTRATION_FORM_LINK:
    "https://forms.gle/Yg2Q1ww8UTvSkZhXA"
};

const SOCIALS = {
  instagram: 'https://www.instagram.com/ieeesb.mmmut/',
  discord: 'https://discord.gg/v5Jz567Q',
  linkedin: 'https://www.linkedin.com/in/ieee-mmmut-57a27b1a6/',
  twitter: 'https://twitter.com/',
  email: 'mailto:yashkushwaha@ieee.org',
  mail: 'yashkushwaha@ieee.org'
};

const MIDDLE_SECTION = {
  TITLE: "What is HackFest'23?",
  LONG_DESCRIPTION:
  "HackFest'23 is 24 hour long running hackathon will be held on 04th and 05th February 2023, We calls for hackers, coders, designers, tech evangelists, creatives, and developers from all disciplines to take a part to win awesome prizes and collaborate with other developers . Throughout the weekend hackers at HackFest'23 will have unique opportunities to learn from each other trying hands in new technologies We are determined to have an all-inclusive and diverse group of students attending.",
  LOGO_EFFECT: true,
  LOGO: ""
};

const FOOTER = {
  VOLUNTEERING_FORM: {
    required: true,
    src: "#Volunteer form link"
  },
  JOIN_TEAM: {
    required: true,
    src: "#Join team link"
  },
  Privacy_policy: {
    required: true,
    src: ""
  },
  Terms_of_use: {
    required: true,
    src: ""
  }
};

const calenderStartingDate = {
  month: 12,
  year: 2022
}


const schedule = [
  {
    "day": "20-12-2022",
    "events": [
      {
        "title": "Opening Ceremoney",
        "timings": "10 AM - 11 AM",
        "link": "https://google.com"
      }
    ]
  },
  {
    "day": "20-12-2022",
    "events": [
      {
        "title": "Event",
        "timings": "11 AM - 12 PM",
        "link": "https://google.com"
      }
    ]
  },
  {
    "day": "20-1-2022",
    "events": [
      {
        "title": "Event",
        "timings": "12 AM - 1 Pm",
        "link": "https://google.com"
      }
    ]
  },
  {
    "day": "21-12-2022",
    "events": [
      {
        "title": "Event",
        "timings": "12 AM - 1 Pm",
        "link": "https://google.com"
      }
    ]
  },
  {
    "day": "21-12-2022",
    "events": [
      {
        "title": "Closing Ceremoney",
        "timings": "6 PM - 7 PM",
        "link": "https://google.com"
      }
    ]
  },
]

const Prizeinfo = [
  [
    //Array 1
    {
      icon: <i className="first fas fa-4x fa-trophy"></i>,
      type: "Overall First",
      content:
        "The first overall prize will be given to a project that outstands all other submissions."
    },
    {
      icon: <i className=" second fas fa-4x fa-medal"></i>,
      type: "Overall Second",
      content:
        "The second overall prize will be given to the second-best project in the hackathon."
    },
    {
      icon: <i className=" third fas fa-4x fa-skiing-nordic"></i>,
      type: "Overall Third",
      content:
        "The third overall prize will be given to the third-best project in the hackathon."
    }
  ],
]

const TeamInfo = [
  [
    // Array 1
   
    {
      Name: "Prof R.K Chauhan",
      role: "Chairman",
      img: RK_Chauhan
    },
    {
      Name: "Dr. Rajan Mishra",
      role: "Event Coordinator / IEEE Branch Councellor",
      img: Rajan
    },
    {
      Name: "Dr. Prabhakar Tiwari",
      role: "Event Coordinator",
      img: Prabhakar
    },
   
  ],


];

const JudgesInfo = [
  [
    // Array 1
    {
      Name: "Yash Kushwaha",
      role: "Chair , IEEE-SB MMMUT",
      github: "https://www.instagram.com/whatisthisyash/",
      linkedin: "https://www.linkedin.com/in/yash-kushwaha23/",
      img: Yash
    },
    {
      Name: "Harshit Agrahari",
      role: "Vice-Chair, IEEE-SB MMMUT",
      github: "https://www.instagram.com/harshit018_/",
      linkedin: "https://www.linkedin.com/in/harshit-agrahari-3515b1195/",
      img: Harshit
    },
    {
      Name: "Shivanand Singh",
      role: "Vice-Chair, IEEE-SB MMMUT",
      github: "",
      linkedin: "https://www.linkedin.com/in/shiva-nand-singh-84a403200/",
      img: Shivanand
    },
  ],
  [
    // Array 2
    {
      Name: "Aryama Jeet Singh",
      role: "Secretary , IEEE-SB MMMUT",
      github: "https://www.instagram.com/aryama_jeet27/",
      linkedin: "https://www.linkedin.com/in/aryama27/",
      img: Aaryama
    },
    {
      Name: "Deepak Kumar",
      role: "Secretary , IEEE-SB MMMUT",
      github: "https://www.instagram.com/deepakkumar_97/",
      linkedin: "https://www.linkedin.com/in/deepakkumarvns/",
      img: Deepak
    },
     {
      Name: "Aditya Singh",
      role: "Secretary , IEEE-SB MMMUT",
      github: "",
      linkedin: "",
      img: Aditya
    },
  ]
];

const sponsorLogos = [
  // [ { src: Aman }], //Array 1
  // [{ src: taskade }, { src: Replit }, { src: qoom }], //Array 2
  // [{ src: interviewC }, { src: pass }, { src: glimpse }], //Array 3
  // [{ src: egg }, { src: ll }, { src: ACF }] //Array 4

];

const titlesponsorLogos = [
  // [{ src: Bobis, link: "https://devfolio.co/" }, ], //Array 1
  // [{ src: taskade }, { src: Replit }, { src: qoom }], //Array 2
  // [{ src: interviewC }, { src: pass }, { src: glimpse }], //Array 3
  // [{ src: egg }, { src: ll }, { src: ACF }] //Array 4

];

const goldsponsorLogos = [
  // [  ], //Array 1
  // [{ src: igl, link: "#" }, { src: upSec, link: "http://www.ieeeup.org/" }], //Array 2
  // [{ src: interviewC }, { src: pass }, { src: glimpse }], //Array 3
  // [{ src: egg }, { src: ll }, { src: ACF }] //Array 4

];

const silversponsorLogos = [
  // [{ src: echo3d, link: "https://www.echo3d.co/" }, { src: wolfram, link: "https://www.wolfram.com/" }, { src: interviewbuddy, link: "https://interviewbuddy.in/" }], //Array 1
  // [{ src: alan, link: "https://alan.app/" }, { src: shivam, link: "#" }],
  // [{ src: taskade }, { src: Replit }, { src: qoom }], //Array 2
  // [{ src: interviewC }, { src: pass }, { src: glimpse }], //Array 3
  // [{ src: egg }, { src: ll }, { src: ACF }] //Array 4

];

const bronzeponsorLogos = [
  // [{ src: replit, link: "https://replit.com/" }, { src: certopus, link: "https://certopus.com/" }, { src: taskade, link: "https://www.taskade.com/" },], //Array 1
  // [{ src: koii, link: "https://www.koii.network/" }, { src: postman, link: "https://postman.com/" }, {src: prayosys, link: "https://prayosys.com/"}],
  // [{src: shivalika, link: "#"}, {src: cuvette, link: "https://www.cuvette.tech/"}],
  // [{ src: taskade }, { src: Replit }, { src: qoom }], //Array 2
  // [{ src: interviewC }, { src: pass }, { src: glimpse }], //Array 3
  // [{ src: egg }, { src: ll }, { src: ACF }] //Array 4

];

const FoodLogos = [
  // [ {src: Becceptor, link: "https://beeceptor.com/" }],
];

const designlogo = [
  // [{ src: digilogo, link: "https://www.instagram.com/digicosmic_studio/" }, { src: streamyard, link: "https://streamyard.com/" }, { src: shutterbugs, link: "https://www.instagram.com/shutterbugs_ddu/?hl=en" }]
];


const frequentlyAskedQuestions = [
  [
    [
      {
        label: "What is a hackathon?",
        content:
          'A hackathon is a 24 hour event where "hackers" will collaborate on creating a functioning software and hardware by the end of the event.'
      },
      {
        label: "Who can attend?",
        content: "HackFest is open to all undergraduate , pursuing any undergraduate degree"
      },
      {
        label: "I am a first time hacker, what should I do?",
        content: "No worries, we love to welcome first-time hackers and start their hacking journey from a hackathon. We have  events which will help you get started with hackathons and hacking in general."
      },
      {
        label: "How team formation works?",
        content: "You can form a team with 3 members in it at maximum."
      }
    ],
    [
      {
        label: "How to register myself in the hackathon?",
        content: "All you need is to register yourself through form attached and join discord, we will guide you through everything there."
      },
      {
        label: "I have more questions?",
        content: "Reach us directly at (yashkushwaha@ieee.org) we would happy to help you."
      }
      ,
      {
        label: "Can I participate as a individual?",
        content: "Yes, Because our goal is learning of every individual, we encourage everyone to participate."
      }
      ,
      {
        label: "Will there be swag?",
        content: "Yes, Participants and winners will receive swags, e-certificates, and much more!"
      }
    ]
  ],

];

export {
  TOP_SECTION,
  MIDDLE_SECTION,
  SOCIALS,
  FOOTER,
  Prizeinfo,
  sponsorLogos,
  titlesponsorLogos,
  goldsponsorLogos,
  silversponsorLogos,
  bronzeponsorLogos,
  TeamInfo,
  JudgesInfo,
  frequentlyAskedQuestions,
  schedule,
  calenderStartingDate,
  designlogo,
  FoodLogos
};
